import { callPutApi, callGetApi } from "./api";

export async function getHomePage() {
      try {
            const response = await callGetApi({ url: "home-page" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateHomePage(data) {
      try {
            const response = await callPutApi({ url: "home-page/update", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}
